import Navigation from './nav/nav'
import {createStore,combineReducers,applyMiddleware} from 'redux'
import {Provider} from 'react-redux'
import {useSelector} from 'react-redux'
import {useEffect} from 'react'
import ReduxThunk from 'redux-thunk'
import {getSocket} from './store/socketClient'
import { loadIceConfig } from './utils/iceConfig'
import PostReducer from './store/posts_reduse'
import auth_reduse from './store/auth_reduse';
import search_reduse from './store/search_reduse';
import follow_reduse from './store/follow_reduse';
import chat_reduse from './store/chat_reduse';
import Comments_reduse from './store/comment_reduse';
import Upds_reduse from './store/updownview_reduse';
import users_reduse from './store/users_reduse';
import lang_reduse from './store/lang_reduse';
import { applyDocumentLang } from './store/langPacks';
import sub_reduse from './store/sub_reduse';
import PushPrompt from './comps/pushPrompt'
import MediaGuard from './comps/mediaGuard'
import './App.css'

const LanguageApplier = () => {
  const code = useSelector(state => state.lang_reduse?.code || 'en');

  useEffect(() => {
    applyDocumentLang(code);
  }, [code]);

  return null;
};

const PresenceTracker = () => {
  const userId = useSelector(state => state.authReduse.id);

  useEffect(() => {
    loadIceConfig()
  }, [])

  useEffect(() => {
    if (!userId) return undefined;
    const socket = getSocket();
    const onConnect = () => socket.emit('con', String(userId));
    socket.on('connect', onConnect);
    if (socket.connected) onConnect();
    return () => {
      socket.off('connect', onConnect);
    };
  }, [userId]);

  return null;
};

const App = () => {


//   const publicVapidKey = 'BEDfzXpSbr8fPkeFh9jmXwuJnmfb4tcwunD9sqip-wCyD12LQOhZ7s1c2mBkwuUSDibQcP_7ECSjvS9jitBReAc';
//   function urlBase64ToUint8Array(base64String) {
//       const padding = "=".repeat((4 - base64String.length % 4) % 4);
//       const base64 = (base64String + padding)
//         .replace(/\-/g, "+")
//         .replace(/_/g, "/");
//
//       const rawData = window.atob(base64);
//       const outputArray = new Uint8Array(rawData.length);
//
//       for (let i = 0; i < rawData.length; ++i) {
//         outputArray[i] = rawData.charCodeAt(i);
//       }
//       return outputArray;
//   }
//   const send = async () =>{
//
//     const register = await navigator.serviceWorker.register('./custom-ws.js',{scope:'/'});
// const subscription = await register.pushManager.subscribe({userVisibleOnly:true,applicationServerKey: urlBase64ToUint8Array(publicVapidKey)})
//
//      await fetch(`/api/sub`,{
//        method:'POST',
//        headers:{'content-Type':'application/json'},
//        body:JSON.stringify(subscription)
//      })
//
//    }
// send().catch(err => console.error(err))

  const root = combineReducers({
PostReducer:PostReducer,
 authReduse:auth_reduse,
 searchReduse:search_reduse,
 followReduse:follow_reduse,
 chatReduse:chat_reduse,
 CommentsReduse:Comments_reduse,
 UpdsReduse:Upds_reduse,
 UsersReduse:users_reduse,
 lang_reduse:lang_reduse,
 sub_reduse:sub_reduse
  });
  const store = createStore(root,applyMiddleware(ReduxThunk))
  return (
    <Provider store={store}>
      <LanguageApplier />
      <PresenceTracker />
      <MediaGuard />
      <PushPrompt />
      <div className="app-shell">
        <Navigation />
      </div>
    </Provider>
);
}

export default App;
